export default __webpack_public_path__ + "static/media/CNo.58-4.e8137b47.jpg";